export default __webpack_public_path__ + "assets/92a4c7240b1f1b6f195ca048ac0704d4.svg";